import React, { forwardRef, useEffect, useRef, useState } from "react";
import moment from "moment";
import {
  destroy,
  END_POINT,
  get,
  getToken,
  TOKEN_NAME,
} from "../../utils/DeApi";
import {
  Alert,
  Button,
  Col,
  Container,
  InputGroup,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import Header from "../App/Header/Header";
import { useTable, useSortBy } from "react-table";
import Loader from "../Loader/Loader";
import TableRowAddAfterIcon from "mdi-react/TableRowAddAfterIcon";
import CancelCircleOutlineIcon from "mdi-react/CancelCircleOutlineIcon";
import DeleteIcon from "mdi-react/DeleteIcon";
import EditIcon from "mdi-react/EditIcon";
import "./ClientDashboard.scss";
import { exportFormData } from "../../utils/exportUtils";
import {
  abbrivateFilingColumns,
  categoryShortHand,
} from "../../utils/StringUtils";
import { useToggle } from "../../hooks";
import ErrorHandler from "../ErrorHandler/ErrorHandler";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const IndeterminateCheckbox = React.forwardRef(
  (
    {
      colShouldBehave,
      widthControlIncrease,
      widthControlDecrease,
      indeterminate,
      ...rest
    },
    ref
  ) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    colShouldBehave(indeterminate);
    if (defaultRef.current?.checked && indeterminate === 0) {
      widthControlIncrease();
    } else if (!defaultRef.current?.checked && !indeterminate) {
      widthControlDecrease();
    }
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return <input type="checkbox" name="allCols" ref={resolvedRef} {...rest} />;
  }
);

function Tabled({
  getTableProps,
  getTableBodyProps,
  headerGroups,
  rows,
  prepareRow,
  allColumns,
  getToggleHideAllColumnsProps,
  state,
  indeterminate,
}) {
  /* *** validate user input for numeric value ( below ) *** */
  const validate = (s) => {
    let charRegex = /^[A-Za-z]+$/;
    let validated = 0;
    if (s !== undefined && s !== null && s !== "") {
      s = s.toString().trim();
      if (!s.match(charRegex)) {
        s = s.replace("$", "");
        validated = s.replace(/,/g, "");
      }
    }
    return validated;
  };

  /* *** transform the numeric value into currency format ( below ) *** */
  const currencyFormat = (val) => {
    let currency = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      // minimumFractionDigits: 0, // (For whole numbers, it will print 2500.10 as $2,500.1)
      // maximumFractionDigits: 2, // (It will round-off 2500.99 to $2,501)
    });
    return currency.format(parseFloat(val));
  };
  return (
    <>
      <div className="row">
        <div className=" fixed-div scrollControl">
          <div className="scrollControl">
            <table
              id="tblDiv"
              className="client-dashboard-tbl table table-stripped "
              {...getTableProps()}
            >
              <thead className="sticky-header">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => {
                      return (
                        <th
                          className="deal-tooltip"
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                          {column.tipText && (
                            <span className="tooltipped">{column.tipText}</span>
                          )}
                          {/* <span>
                          {
                          column.isSorted ? 
                              column.isSortedDesc
                                ? ' 🔽'
                                : ' 🔼'
                            : ''
                          }
                        </span> */}
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.length > 0 ? (
                  rows.map((row, i) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              // className="text deal-tooltip-td"
                              className={` ${
                                cell.column.Header !== "Actions"
                                  ? "text deal-tooltip-td"
                                  : "text "
                              }`}
                              {...cell.getCellProps()}
                            >
                              <span className="spanContainer ">
                                {cell.render("Header") === "SR." ? (
                                  i + 1
                                ) : cell.render("Header") === "Filing Date" ? (
                                  moment(cell.value).format("MM/DD/YYYY")
                                ) : cell.render("Header") ===
                                  "EJV ID re-checked Date" ? (
                                  cell.value === "" || cell.value === null ? (
                                    ""
                                  ) : (
                                    moment(cell.value).format("MM/DD/YYYY")
                                  )
                                ) : cell.render("Header") ===
                                  " Agreement Type" ? (
                                  cell.value === "-1" ? (
                                    ""
                                  ) : (
                                    cell.value
                                  )
                                ) : cell.render("Header") ===
                                  "Previous Date" ? (
                                  cell.value === "" || cell.value === null ? (
                                    ""
                                  ) : (
                                    moment(cell.value).format("MM/DD/YYYY")
                                  )
                                ) : cell.render("Header") ===
                                  "Loan $$ Amount" ? (
                                  cell.value === "0" ? (
                                    ""
                                  ) : (
                                    currencyFormat(validate(cell.value))
                                  )
                                ) : cell.render("Header") ===
                                  "Loan Exist in LC?" ? (
                                  cell.value === "-1" ? (
                                    ""
                                  ) : cell.value === "1" ? (
                                    "Yes"
                                  ) : (
                                    "No"
                                  )
                                ) : cell.render("Header") ===
                                  "Borrower Exist in LC?" ? (
                                  cell.value === "-1" ? (
                                    ""
                                  ) : cell.value === "1" ? (
                                    "Yes"
                                  ) : (
                                    "No"
                                  )
                                ) : cell.render("Header") ===
                                  "Filing Entity exist in LC?" ? (
                                  cell.value === "-1" ? (
                                    ""
                                  ) : cell.value === "1" ? (
                                    "Yes"
                                  ) : (
                                    "No"
                                  )
                                ) : cell.render("Header") === "Filing URL" ? (
                                  <a
                                    href={cell.value}
                                    className="documentClass"
                                  >
                                    Filing Url
                                  </a>
                                ) : cell.render("Header") === "SEC.gov URL" ? (
                                  <a
                                    href={cell.value}
                                    className="documentClass"
                                  >
                                    Document Url
                                  </a>
                                ) : cell.render("Header") ===
                                  "Date the filing was reviewed in Loan Connector for company presence" ? (
                                  moment(cell.value).format("MM/DD/YYYY")
                                ) : cell.render("Header") === "Signing Date" ? (
                                  cell.value !== null ? (
                                    moment(cell.value).format("MM/DD/YYYY")
                                  ) : (
                                    ""
                                  )
                                ) : cell.render("Header") ===
                                  "Date doc captured from SEC" ? (
                                  moment(cell.value).format("MM/DD/YYYY")
                                ) : cell.render("Header") ===
                                  "Uploaded Dated on LC" ? (
                                  cell.value === "" || cell.value === null ? (
                                    ""
                                  ) : (
                                    moment(cell.value).format("MM/DD/YYYY")
                                  )
                                ) : cell.render("Header") ===
                                  "LC Review date" ? (
                                  moment(cell.value).format("MM/DD/YYYY")
                                ) : (
                                  cell.render("Cell")
                                )}
                              </span>
                              {cell.value !== null &&
                                cell.value !== "" &&
                                cell.value !== "0" && (
                                  <span className="tooltipped-td">
                                    {cell.render("Header") === "SR." ? (
                                      i + 1
                                    ) : cell.render("Header") ===
                                      "Filing Date" ? (
                                      moment(cell.value).format("MM/DD/YYYY")
                                    ) : cell.render("Header") ===
                                      "Filing Name" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Borrower Name" ? (
                                      cell.value
                                    ) : cell.render("Header") === "CIK #" ? (
                                      cell.value
                                    ) : cell.render("Header") === "Film #" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Form Type" ? (
                                      cell.value
                                    ) : cell.render("Header") === "Exhibit" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Title Name" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Agreement Type" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Amendment #" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Lead Arranger/Bookrunner" ? (
                                      cell.value
                                    ) : cell.render("Header") === "LC ID" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Recorded by" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Uploaded by" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "PixelEdge Comment" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "Refinitiv Comment" ? (
                                      cell.value
                                    ) : cell.render("Header") ===
                                      "EJV ID re-checked Date" ? (
                                      cell.value === "" ||
                                      cell.value === null ? (
                                        ""
                                      ) : (
                                        moment(cell.value).format("MM/DD/YYYY")
                                      )
                                    ) : cell.render("Header") ===
                                      " Agreement Type" ? (
                                      cell.value === "-1" ? (
                                        ""
                                      ) : (
                                        cell.value
                                      )
                                    ) : cell.render("Header") ===
                                      "Previous Date" ? (
                                      cell.value === "" ||
                                      cell.value === null ? (
                                        ""
                                      ) : (
                                        moment(cell.value).format("MM/DD/YYYY")
                                      )
                                    ) : cell.render("Header") ===
                                      "Loan $$ Amount" ? (
                                      cell.value === "0" ? (
                                        ""
                                      ) : (
                                        currencyFormat(validate(cell.value))
                                      )
                                    ) : cell.render("Header") ===
                                      "Loan Exist in LC?" ? (
                                      cell.value === "-1" ? (
                                        ""
                                      ) : cell.value === "1" ? (
                                        "Yes"
                                      ) : (
                                        "No"
                                      )
                                    ) : cell.render("Header") ===
                                      "Borrower Exist in LC?" ? (
                                      cell.value === "-1" ? (
                                        ""
                                      ) : cell.value === "1" ? (
                                        "Yes"
                                      ) : (
                                        "No"
                                      )
                                    ) : cell.render("Header") ===
                                      "Filing Entity exist in LC?" ? (
                                      cell.value === "-1" ? (
                                        ""
                                      ) : cell.value === "1" ? (
                                        "Yes"
                                      ) : (
                                        "No"
                                      )
                                    ) : cell.render("Header") ===
                                      "Filing URL" ? (
                                      <a
                                        href={cell.value}
                                        className="documentClass"
                                      >
                                        Filing Url
                                      </a>
                                    ) : cell.render("Header") ===
                                      "SEC.gov URL" ? (
                                      <a
                                        href={cell.value}
                                        className="documentClass"
                                      >
                                        Document Url
                                      </a>
                                    ) : cell.render("Header") ===
                                      "Date the filing was reviewed in Loan Connector for company presence" ? (
                                      moment(cell.value).format("MM/DD/YYYY")
                                    ) : cell.render("Header") ===
                                      "Signing Date" ? (
                                      moment(cell.value).format("MM/DD/YYYY")
                                    ) : cell.render("Header") ===
                                      "Date doc captured from SEC" ? (
                                      moment(cell.value).format("MM/DD/YYYY")
                                    ) : cell.render("Header") ===
                                      "Uploaded Dated on LC" ? (
                                      cell.value === "" ||
                                      cell.value === null ? (
                                        ""
                                      ) : (
                                        moment(cell.value).format("MM/DD/YYYY")
                                      )
                                    ) : cell.render("Header") ===
                                      "LC Review date" ? (
                                      moment(cell.value).format("MM/DD/YYYY")
                                    ) : cell.render("Header") === "Action" ? (
                                      cell.render("cell")
                                    ) : // cell.render("Cell")
                                    null}
                                  </span>
                                )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={31 - indeterminate}>
                      <h3> No records found!</h3>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

function NoDataFound() {
  return (
    <Col>
      <Alert variant="default" className="alert-deal-style w-100 shadow">
        <h4 className="mb-0">No Data Found!</h4>
      </Alert>
    </Col>
  );
}

const ClientDashboard = (props) => {
  const [formsData, setFormsData] = useState([]);
  const [tabIndex, setTabIndex] = useState("TBU");
  const [error, setError] = useState([]);
  const [indeterminate, setIndeterminate] = useState(null);
  const [filedAt, setFiledAt] = useState(
    moment().subtract(1, "days").format("YYYYMMDD")
  );
  const [isLoading, setIsLoading] = useState(false);
  const [dynamicWidth, setDynamicWidth] = useState(100);
  const subscribedPromises = useRef([]);
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState([]);
  const [show, setShow] = useState(false);
  const [entity, setEntity] = useState({});
  const [isSubmitting, toggleIsSubmitting] = useToggle(false);

  /* *** fetch filing data *** */
  const getFilings = () => {
    const { promise, cancel } = get("/fetchForms", {
      params: {
        filed_at: moment(filedAt).format("YYYY-MM-DD"),
        offset: 0,
        limit: 5000,
      },
    });

    promise
      .then((response) => {
        setFormsData(response.data);
        setRecords(response.data);
        setIsLoading(false);
        setDecreaseWidth();
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
    subscribedPromises.current.push(cancel);
  };

  /* *** custom date input *** */
  const DateInput = forwardRef(({ value, onClick }, ref) => {
    return (
      <button
        className="btn btn-success-deal-style roundedEdges shadow mr-3"
        onClick={onClick}
        ref={ref}
      >
        {value}
        <span className="material-icons">expand_more</span>
      </button>
    );
  });

  /* *** CSV-file download function *** */
  // const exportFilings = ()=> {
  //   const filedAt = moment(filedAt).format("MM-DD-YYYY");
  //   //  const fileName = `DealSense Log - ${moment(filedAt).format("MM-DD-YYYY")}.csv`
  // }

  /* *** fetching forms data from api ( below ) *** */
  useEffect(() => {
    setIsLoading(true);
    getFilings();
  }, [filedAt]);

  /* *** un-subscribing all promises *** */
  useEffect(() => {
    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((cancel) => cancel());
    };
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "SR.",
        accessor: "",
        tipText: "Serial.",
        cell: (row, index) => index + 1,
        width: 15,
      },
      {
        Header: "Filing Date",
        accessor: "filing_date",
        tipText: "Filing Date",
        width: 150,
      },
      {
        Header: "Filing Name",
        accessor: "company_name",
        tipText: "Company Filing Name",
        width: 300,
      },
      {
        Header: "Borrower Name",
        accessor: "borrower_name",
        tipText: "Borrower Name",
        width: 300,
      },
      {
        Header: "CIK #",
        accessor: "cik_number",
        tipText: "CIK Number",
        width: 200,
      },
      {
        Header: "Film #",
        accessor: "film_number",
        tipText: "Film Num",
        width: 200,
      },
      {
        Header: "EJV ID",
        accessor: "ejv_id",
        tipText: "EJV ID",
        width: 200,
      },
      {
        Header: "EJV ID re-checked Date",
        accessor: "ejv_date",
        tipText: "Date EJV ID was re-checked to the BLUES",
        width: 200,
      },
      {
        Header: "Form Type",
        accessor: "form_type",
        tipText: "Form Type",
        width: 150,
      },
      {
        Header: "Exhibit",
        accessor: "exhibit",
        tipText: "Exhibit",
        width: 150,
      },
      {
        Header: "Title Name",
        accessor: "title_name",
        tipText: "Title Name",
        width: 300,
      },
      {
        Header: "Agreement Type",
        accessor: "agreement_type",
        tipText: "Agreement Type (O, A, A&R, Warrant or Waiver)",
        width: 350,
      },
      {
        Header: "Signing Date",
        accessor: "signing_date",
        tipText: "Signing Date",
        width: 200,
      },
      {
        Header: "Previous Date",
        accessor: "prev_amend_date",
        tipText: "Previous Date being Amended",
        width: 200,
      },
      {
        Header: "Amendment #",
        accessor: "amend_numb",
        tipText: "Amendment number",
        width: 300,
      },
      {
        Header: "Loan $$ Amount",
        accessor: "loan_amount",
        tipText: "Loan $$ Amount (only needed for O, A/R)",
        width: 300,
      },
      {
        Header: "Lead Arranger/Bookrunner",
        accessor: "book_runner",
        tipText: "Lead Arranger/Bookrunner",
        width: 350,
      },
      {
        Header: "Loan Exist in LC?",
        accessor: "loan_exists_lc",
        tipText: "Does Loan Exist in Loan Connector?",
        width: 100,
      },
      {
        Header: "LC ID",
        accessor: "lc_deal_id",
        tipText: "Loan Connector Deal ID",
        width: 300,
      },
      {
        Header: "Borrower Exist in LC?",
        accessor: "borrower_exists_lc",
        tipText: "Does Borrower Exist in Loan Connector?",
        width: 100,
      },
      {
        Header: "Filing Entity exist in LC?",
        accessor: "filing_entry_exists_lc",
        tipText: "Does Filing Entity exist in Loan Connector?",
        width: 100,
      },
      {
        Header: "Loan Doc #",
        accessor: "loan_doc_num",
        tipText: "Loan Doc #",
        width: 300,
      },
      {
        Header: "Date doc captured from SEC",
        accessor: "doc_capture_date",
        tipText: "Date document was captured from SEC",
        width: 200,
      },
      {
        Header: "Uploaded Dated on LC",
        accessor: "doc_upload_lc_date",
        tipText: "Date doc was uploaded to Loan Connector",
        width: 200,
      },
      {
        Header: "Filing URL",
        accessor: "filing_url",
        tipText: "Filing URL",
        width: 300,
      },
      {
        Header: "SEC.gov URL",
        accessor: "sec_url",
        tipText: "Sec.gov URL",
        width: 300,
      },
      {
        Header: "Recorded by",
        accessor: "analyst_name_who_recorded",
        tipText: "Analyst who recorded the document",
        width: 350,
      },
      {
        Header: "Uploaded by",
        accessor: "analyst_name_who_upload",
        tipText: "Analyst who uploaded the document to Loan Connector",
        width: 300,
      },
      {
        Header: "LC Review date",
        accessor: "filing_review_date",
        tipText:
          "Date the filing was reviewed in Loan Connector for company presence",
        width: 200,
      },
      {
        Header: "PixelEdge Comment",
        accessor: "pixeledge_comment",
        tipText: "PixelEdge Comment",
        width: 350,
      },
      {
        Header: "Refinitiv Comment",
        accessor: "refinitive_comment",
        tipText: "Refinitiv Comment",
        width: 350,
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <>
            <span
              className="p-1 ml-1 rounded-circle btn btn-warning btn-sm"
              onClick={() => showDeleteModal(row.original)}
            >
              <DeleteIcon size={16} />
            </span>
            <Link
              to={`/form-filing?selection_id=${row?.original?.selections?.meta_id}&filing_id=${row?.original?.selections?.filing_id}`}
              className="text-decoration-none p-1 ml-1 rounded-circle btn btn-warning btn-sm"
              target="_blank"
              onClick={() => {
                setFormData(row.original);
              }}
            >
              <EditIcon size={20} />
            </Link>
          </>
        ),
      },
    ],
    [formsData]
  );

  const setFormData = (data) => {
    let selection = {
      formType: data.selections.form_type,
      createdAt: data.selections.created_at,
      email: data.selections.email,
      filedAt: data.selections.filed_at,
      id: data.selections.meta_id,
      analyst_id: data.selections.analyst_id,
      documentId: data.selections.document_id,
      documentUrl: data.selections.document_url,
    };

    let filing = {
      filedAt: data.filing_date,
      companyName: data.company_name,
      cik: data.cik_number,
      formType: data.form_type,
      linkToHtml: data.filing_url,
      id: data.id,
      accessionNo: data.selections.filing_id,
      entities: [
        {
          filmNo: data.film_number,
        },
      ],
    };

    localStorage.setItem("selection", JSON.stringify(selection));
    localStorage.setItem("filing", JSON.stringify(filing));
    localStorage.setItem(
      "doc",
      JSON.stringify({
        documentUrl: data.selections.document_url,
        type: data.selections.form_type,
        formType: data.form_type,
      })
    );
  };
  const showDeleteModal = (row) => {
    setError("");
    setEntity(row);
    setShow(true);
  };

  const onClose = () => {
    setShow(false);
  };

  const handleDelet = () => {
    toggleIsSubmitting();
    const { promise, cancel } = destroy(`client/delete/${entity?.meta_id}`);
    promise
      .then((response) => {
        if (response.success) {
          let index = formsData.findIndex(
            (item) => item.meta_id === entity.meta_id
          );

          if (index !== -1) {
            let newFormsData = [...formsData];
            newFormsData.splice(index, 1);
            setFormsData(newFormsData);
          }
          onClose();
        }
      })
      .catch((error) => setError(error))
      .finally(toggleIsSubmitting);
    subscribedPromises.current.push(cancel);
  };

  const DeleteClientDataContent = ({ onClose, show }) => {
    /* *** returning content ( below ) *** */
    return (
      <Modal
        show={show}
        onHide={() => {
          onClose();
          setError();
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="color-deal-style">Delete Record</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete CIK#{" "}
          <span className="font-font-weight-bold text-danger">
            {entity?.cik_number}
          </span>
          ?{error && <ErrorHandler error={error} />}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={handleDelet}
            className="roundedEdges"
            disabled={isSubmitting}
          >
            {isSubmitting && (
              <Spinner
                as="span"
                animation="border"
                variant="light"
                size="sm"
                className="m-1"
              />
            )}{" "}
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  let data = React.useMemo(() => {
    let data = [];
    formsData.map((cat) => {
      if (cat.category === `${categoryShortHand(tabIndex)}`) {
        data.push(cat);
      }
    });
    return data;
  }, [formsData, tabIndex]);

  const colBehaviour = (val) => {
    setIndeterminate(val);
  };

  /* *** searching *** */
  const searchable = (val) => {
    setSearch(val);
    let searched = String(val).toLowerCase().replace("/", "-");

    setFormsData(
      records.filter((item) => {
        let bool = false;
        Object.entries(item).some((entry) => {
          bool = entry[1]?.toString()?.toLowerCase()?.includes(searched);
          return bool;
        });
        return bool;
      })
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    allColumns,
    getToggleHideAllColumnsProps,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: [
          "SR.",
          "loan_exists_lc",
          "lc_deal_id",
          "borrower_exists_lc",
          "filing_entry_exists_lc",
          "loan_doc_num",
          "doc_capture_date",
          "doc_upload_lc_date",
          "filing_url",
          "sec_url",
          "analyst_name_who_recorded",
          "analyst_name_who_upload",
          "filng_review_date",
          "pixeledge_comment",
          "refinitive_comment",
        ],
      },
    },
    useSortBy
  );

  const handleLogic = (evt, colName) => {
    let isChecked = !evt.checked;
    switch (colName) {
      case "SR.":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(
            isChecked ? Number(dynamicWidth) + 3 : Number(dynamicWidth) - 3
          );
        } else {
          setDecreaseWidth();
        }
        break;
      // =====================
      case "filing_date":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "company_name":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 3 : dynamicWidth - 3);
        } else {
          setDecreaseWidth();
        }
        break;
      case "borrower_name":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 3 : dynamicWidth - 3);
        } else {
          setDecreaseWidth();
        }
        break;
      case "amend_numb":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "cik_number":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "film_number":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "ejv_id":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "ejv_date":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "title_name":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 1 : dynamicWidth - 1);
        } else {
          setDecreaseWidth();
        }
        break;
      case "form_type":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "exhibit":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "signing_date":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "agreement_type":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "prev_amend_date":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      // ***********************************
      case "loan_amount":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "book_runner":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      // ================
      case "loan_exists_lc":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "lc_deal_id":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "borrower_exists_lc":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 3 : dynamicWidth - 3);
        } else {
          setDecreaseWidth();
        }
        break;
      case "filing_entry_exists_lc":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 4 : dynamicWidth - 4);
        } else {
          setDecreaseWidth();
        }
        break;
      case "loan_doc_num":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 3 : dynamicWidth - 3);
        } else {
          setDecreaseWidth();
        }
        break;
      case "doc_capture_date":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 3 : dynamicWidth - 3);
        } else {
          setDecreaseWidth();
        }
        break;
      case "doc_upload_lc_date":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 1 : dynamicWidth - 1);
        } else {
          setDecreaseWidth();
        }
        break;
      case "filing_url":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 1 : dynamicWidth - 1);
        } else {
          setDecreaseWidth();
        }
        break;
      case "sec_url":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 1 : dynamicWidth - 1);
        } else {
          setDecreaseWidth();
        }
        break;
      case "analyst_name_who_recorded":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 1 : dynamicWidth - 1);
        } else {
          setDecreaseWidth();
        }
        break;
      case "filng_review_date":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 1 : dynamicWidth - 1);
        } else {
          setDecreaseWidth();
        }
        break;
      case "analyst_name_who_upload":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "refinitive_comment":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      case "pixeledge_comment":
        if (dynamicWidth >= 100 && indeterminate <= 12) {
          setDynamicWidth(isChecked ? dynamicWidth + 2 : dynamicWidth - 2);
        } else {
          setDecreaseWidth();
        }
        break;
      default:
        setDecreaseWidth();
        break;
    }
  };

  const setIncreaseWidth = (val = 158) => {
    setDynamicWidth(val);
  };

  const setDecreaseWidth = () => {
    setDynamicWidth(100);
  };
  const popover = (
    <Popover id="popover-positioned-right" title="Popover">
      <Col>
        <h3 className="mt-1">Toggle Columns</h3>
      </Col>
      <hr />
      <Col>
        <h4>
          <IndeterminateCheckbox
            {...getToggleHideAllColumnsProps()}
            widthControlIncrease={setIncreaseWidth}
            widthControlDecrease={setDecreaseWidth}
            colShouldBehave={colBehaviour}
          />{" "}
          Show All
          <button
            className="float-right"
            aria-label="Close"
            onClick={() => document.body.click()}
            style={{
              display: "inline-block",
              marginTop: "-0.4%",
              border: "none",
              backgroundColor: "transparent",
            }}
          >
            <CancelCircleOutlineIcon size={35} />
          </button>
        </h4>
      </Col>
      <hr />
      <Container>
        <Row style={{ paddingLeft: "5%" }}>
          {allColumns.map((column) => (
            <span className="col-md-6" key={column.id}>
              <label>
                <input
                  type="checkbox"
                  onClick={() =>
                    handleLogic(column.getToggleHiddenProps(), column.id)
                  }
                  name={column.id}
                  {...column.getToggleHiddenProps()}
                />{" "}
                {abbrivateFilingColumns(column.id)}
              </label>
            </span>
          ))}
        </Row>
      </Container>
    </Popover>
  );
  var pixels = "";
  var elem = document.getElementById(
    "uncontrolled-tab-example-tabpane-" + tabIndex
  );
  if (elem !== undefined && elem !== null) {
    if (elem.querySelector("#tblDiv") !== null) {
      pixels = elem.querySelector("#tblDiv").offsetWidth;
    }
  }

  var width = "";
  if (pixels === 100 || pixels < 100) {
    width = "103%";
  } else {
    width = `${pixels + 15}px`;
  }

  if (isLoading) return <Loader />;

  return (
    <>
      <Header user={props.user} title={"Client Dashboard"} />
      <Container className="MainContent">
        <Col className="mt-2">
          {/* <div className="sticky-div mb-3" style={{paddingBottom: '2%', width: `${dynamicWidth}%`}}> */}
          {/* <div className="sticky-div mb-3" style={{paddingBottom: '2%', width: width}}> */}
          <div className="sticky-div mb-3 d-flex justify-content-between pb-2 ">
            {/* <Row> */}
            <div className="d-flex justify-content-lg-start roundedEdges">
              <React.Fragment>
                <DatePicker
                  portalId="root-portal"
                  className="btn-block"
                  selected={moment(filedAt).toDate()}
                  onChange={(date) => {
                    setFiledAt(moment(date).format("YYYYMMDD"));
                  }}
                  customInput={<DateInput />}
                />
              </React.Fragment>

              {/* pop-over start */}
              {formsData.length ? (
                <div>
                  <OverlayTrigger
                    rootClose={true}
                    container={this}
                    trigger="click"
                    placement="right"
                    overlay={popover}
                  >
                    <Button
                      variant="default"
                      className="btn btn-outline-deal-style roundedEdges shadow"
                    >
                      <TableRowAddAfterIcon size={20} /> All Columns
                    </Button>
                  </OverlayTrigger>
                </div>
              ) : null}
              {/* pop-over end */}
            </div>

            <div className="d-flex justify-content-end ">
              <div>
                <input
                  type="text"
                  className="form-control roundedEdges"
                  placeholder="Search here..."
                  onChange={(event) => searchable(event.target.value)}
                  value={search}
                />
              </div>
              <div className="col-sm-4 p-0 mt-1">
                <a
                  href={`${END_POINT}/${moment(filedAt).format(
                    "YYYY-MM-DD"
                  )}/sheet/download?token=${getToken(TOKEN_NAME)}`}
                  className="override-anchor-effect custom-adjustment float-right"
                  style={{ marginTop: "2%" }}
                >
                  Export{" "}
                  <span className="material-icons color-deal-style">
                    description
                  </span>
                </a>
              </div>
            </div>
            {/* </Row> */}
          </div>
          {formsData.length ? (
            <>
              <div>
                <Tabs
                  defaultActiveKey="TBU"
                  id="uncontrolled-tab-example"
                  className="mb-3 color-deal-style"
                  onSelect={(evt) => {
                    setTabIndex(evt);
                  }}
                >
                  <Tab
                    eventKey="TBU"
                    title="Documents to be uploaded"
                    className="color-deal-style"
                  >
                    <Tabled
                      columns={columns}
                      data={data}
                      getTableProps={getTableProps}
                      getTableBodyProps={getTableBodyProps}
                      headerGroups={headerGroups}
                      rows={rows}
                      prepareRow={prepareRow}
                      allColumns={allColumns}
                      getToggleHideAllColumnsProps={
                        getToggleHideAllColumnsProps
                      }
                      state={state}
                      indeterminate={indeterminate}
                    />
                  </Tab>

                  <Tab
                    eventKey="NF-LC"
                    title="Borrowers/Company Filing do not exist in Loan Connector"
                  >
                    {/* Calling table component */}
                    <Tabled
                      columns={columns}
                      data={data}
                      getTableProps={getTableProps}
                      getTableBodyProps={getTableBodyProps}
                      headerGroups={headerGroups}
                      rows={rows}
                      prepareRow={prepareRow}
                      allColumns={allColumns}
                      getToggleHideAllColumnsProps={
                        getToggleHideAllColumnsProps
                      }
                      state={state}
                      indeterminate={indeterminate}
                    />
                  </Tab>

                  <Tab eventKey="LT-25" title="Less than 25M">
                    <Tabled
                      columns={columns}
                      data={data}
                      getTableProps={getTableProps}
                      getTableBodyProps={getTableBodyProps}
                      headerGroups={headerGroups}
                      rows={rows}
                      prepareRow={prepareRow}
                      allColumns={allColumns}
                      getToggleHideAllColumnsProps={
                        getToggleHideAllColumnsProps
                      }
                      state={state}
                      indeterminate={indeterminate}
                    />
                  </Tab>

                  <Tab eventKey="DRFT" title="Draft">
                    <Tabled
                      columns={columns}
                      data={data}
                      getTableProps={getTableProps}
                      getTableBodyProps={getTableBodyProps}
                      headerGroups={headerGroups}
                      rows={rows}
                      prepareRow={prepareRow}
                      allColumns={allColumns}
                      getToggleHideAllColumnsProps={
                        getToggleHideAllColumnsProps
                      }
                      state={state}
                      indeterminate={indeterminate}
                    />
                  </Tab>

                  <Tab eventKey="PR" title="Press Release">
                    <Tabled
                      columns={columns}
                      data={data}
                      getTableProps={getTableProps}
                      getTableBodyProps={getTableBodyProps}
                      headerGroups={headerGroups}
                      rows={rows}
                      prepareRow={prepareRow}
                      allColumns={allColumns}
                      getToggleHideAllColumnsProps={
                        getToggleHideAllColumnsProps
                      }
                      state={state}
                      indeterminate={indeterminate}
                    />
                  </Tab>

                  <Tab eventKey="QTN" title="Questions">
                    <Tabled
                      columns={columns}
                      data={data}
                      getTableProps={getTableProps}
                      getTableBodyProps={getTableBodyProps}
                      headerGroups={headerGroups}
                      rows={rows}
                      prepareRow={prepareRow}
                      allColumns={allColumns}
                      getToggleHideAllColumnsProps={
                        getToggleHideAllColumnsProps
                      }
                      state={state}
                      indeterminate={indeterminate}
                    />
                  </Tab>
                </Tabs>
                <DeleteClientDataContent show={show} onClose={onClose} />
              </div>
            </>
          ) : (
            <NoDataFound />
          )}
        </Col>

        {/* </Row> */}
      </Container>
    </>
  );
};

export default ClientDashboard;
